<template>
  <!--nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav-->
  <router-view/>
</template>

<style lang="scss">
  /* 引入全局响应式em规则 */
  @import './assets/responsive-em.css';
  
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
//    text-align: center;
    color: #2c3e50;
    
    /* 禁用移动端手势操作，优化手写体验 */
    touch-action: none;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    user-select: none;
  }

  nav {
    padding: 30px;

    a {
      font-weight: bold;
      color: #2c3e50;

      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }
/*
  @media screen and (orientation: landscape) {
    body {
      transform-origin: top left;
      transform: rotate(90deg) translateY(-100%);
      width: 100vh !important;
      height: 100vw !important;
    }
  }*/
</style>
